import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { ReportResponse } from '../../responses/orchestrator-patient/report.response';
import { LogDownloadReportRequest } from '../../requests/medical-record/log-download-report.request';

@Injectable({
  providedIn: 'root'
})
export class LogDownloadReportService extends CommonService {

  constructor(private httpClient: HttpClient) {
    super();
  }

  public downloadReport(request: LogDownloadReportRequest): Observable<ReportResponse> {
    let uri = `LogDownloadReport`;
    return this.httpClient.post<ReportResponse>(environment.urlApiMedicalRecord + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}